// Body of the loadup (mattress pickup request) confirmation page: the legacy
// sealy account-page layout with the static thank-you copy. Sealy serves
// en-us only, so the plain literals match the legacy {% blocktrans %} output.
import React from "react";

import accountFormStyles from "../../styles/composable/account-form.module.scss";

export const LoadupRequestConfirmationPageBody = (): React.JSX.Element => (
    <div className="l-capped-width">
        <header>
            <h2>Mattress Pickup Request</h2>
        </header>

        <div className={accountFormStyles.accountForm}>
            <p>Thank you for submitting a Mattress Pickup Request Form!</p>
            <p>
                Please allow 1-3 business days for our pickup partners to email
                you for scheduling.
            </p>
        </div>
    </div>
);
